import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const IframeContainer = styled.div`
  width: 100%;
  height: 75%;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  
  border: none;
`;

export const CloseButton = styled.button`
  && {
    position: absolute;
    top: 30px;
    right: 30px;
    background: rgba(255,255,255,0.7);
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: #333;
    z-index: 1000;
    line-height: 1;

    border-radius: 50%;

    line-height: 17px;
    padding: 5px;

    &:hover {
      color: #000;
    }
  }
`;
